import { StyleSheet, View, Image } from 'react-native';
import React from 'react';
import InfoText from './InfoText';
const HeroSection = () => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.flashImageContainer },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_flash.png" }, style: { width: 36, height: 36 } }),
            React.createElement(View, { style: styles.flashTextRender },
                React.createElement(InfoText, { label: "Get instant\ncash" }))),
        React.createElement(View, { style: styles.divider }),
        React.createElement(View, { style: styles.rateImageContainer },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_percent.png" }, style: { width: 36, height: 36 } }),
            React.createElement(View, { style: styles.rateTextRender },
                React.createElement(InfoText, { label: "Portfolio keeps growing" }))),
        React.createElement(View, { style: styles.divider }),
        React.createElement(View, { style: styles.securityImageContainer },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_lock.png" }, style: { width: 36, height: 36 } }),
            React.createElement(View, { style: styles.securityTextRender },
                React.createElement(InfoText, { label: "Investments are safe" })))));
};
export default HeroSection;
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 16,
        borderWidth: 1,
        borderColor: '#E7EBFA',
        marginHorizontal: 16,
        marginTop: 20,
        backgroundColor: '#F9FAFB',
    },
    rateImage: {
        height: 24,
        width: 24,
    },
    securityImage: {
        height: 24,
        width: 24,
    },
    flashImage: {
        height: 24,
        width: 24,
    },
    flashImageContainer: {
        paddingLeft: 24,
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    rateImageContainer: {
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    securityImageContainer: {
        paddingRight: 24,
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    imageRender: {
        padding: 12,
        borderRadius: 1000,
        backgroundColor: '#F3F5FC',
        marginBottom: 2,
    },
    rateTextRender: {
        paddingHorizontal: 10,
    },
    flashTextRender: {},
    securityTextRender: {
        paddingHorizontal: 10,
    },
    divider: {
        marginHorizontal: 10,
        borderWidth: 1,
        borderColor: '#E4E7EC',
        marginVertical: 28,
    },
});
